import { ShipmentWaybillMaterialListSearchCriteria } from '../../models/shipment-waybill-materials.model';

export class ShipmentWaybillMaterialsLoad {
  constructor(public payload: ShipmentWaybillMaterialListSearchCriteria) {}
  public static readonly type = '[ShipmentWaybillMaterials] Materials Load';
}

export class ShipmentWaybillMaterialsInitialState {
  public static readonly type = '[ShipmentWaybillMaterials] Set Initial State';
}
